module.exports = __webpack_public_path__ + "img/module10.609a5e29.png";